<template>
    <fragment>
        <div id="namoEditor">
            <textarea :id="getEditorId"
                      :name="getEditorId"
                      alt="initText"
                      title="initText"
                      style="width:100%; height:400px; font-size:11pt" />
        </div>
    </fragment>
</template>

<script>
import Vue                          from 'vue';
import { mapActions, mapGetters }   from 'vuex';
import _                            from 'lodash';
import $                            from 'jquery';
import axios                        from 'axios';
import store                        from '@/vuex/store';
import SDLLocale                    from '@/mixin/SDLLocale';
import { SDLUtil }                  from '@/utils';
import { EventBus }                 from '@/utils/EventBus';

let CrossEditor = null;

export default {
    name: 'CrossEditor',
    props: {
        editorId:   { required: true },
        editorData: { default: '' },
    },
    data() {
        return {
            customToolbar: "fontname|fontsize|undo|redo|word_style|word_color|word_justify|word_listset|word_indentset|tableinsert|image|emoticon|spellchecker|information"
        }
    },
    computed: {
        ...mapGetters({
            locale: 'getLocale',
        }),
        getEditorId() {
            return this.editorId;
        },
    },
    methods: {
        setEditorParams() {
            const params = {
                Width: '100%',
                UserLang: 'enu',
                FullScreen: false,
                DisplayLoadingBar: true,
                Menu: false,
                CreateTab: '0',
                ActiveTab: 0,
                ShowRuler: true,
                ParentEditor: document.getElementById('namoEditor'),
                WebsourcePath: `${SDLUtil.API_URL}/crosseditor`,
            };

            return params;
        },
        initCrossEditor(editorId) {
            this.$log.info('＃ CrossEditor.vue initCrossEditor method => ', editorId);
            if (typeof editorId === 'undefined') return SDLUtil.errorAlert('EditorId is null');

            this.$nextTick(() => {
                if (CrossEditor === null) {
                    window.OnInitCompleted = this.OnInitCompleted;
                    CrossEditor = new window.NamoSE(editorId);
                    CrossEditor.params = this.setEditorParams();
                    CrossEditor.params.AllowBrowserContextMenu = false;
                    CrossEditor.params.NoUseToolBarPanelHTML = false;
                    CrossEditor.params.NoUseInsertParagraph = true;
                    if ('http://127.0.0.1:8080' === `${SDLUtil.API_URL}`) {
                        CrossEditor.params.UploadEtcFileExecutePath = `${SDLUtil.API_URL}/crosseditor/websource/jsp/FileUploadLocal.jsp`;
                        CrossEditor.params.UploadFileExecutePath = `${SDLUtil.API_URL}/crosseditor/websource/jsp/ImageUploadLocal.jsp`;
                    } else {
                        CrossEditor.params.UploadEtcFileExecutePath = `${SDLUtil.API_URL}/crosseditor/websource/jsp/FileUpload.jsp`;
                        CrossEditor.params.UploadFileExecutePath = `${SDLUtil.API_URL}/crosseditor/websource/jsp/ImageUpload.jsp`;
                    }
                    CrossEditor.params.CreateToolbar = this.customToolbar;
                    CrossEditor.params.OnInitCompleted = OnInitCompleted;
                    CrossEditor.params.DisplayLoadingBar = false;
                    CrossEditor.EditorStart();

                    // 여러개의 에디터를 생성할 때 editorId 로 window param 을 생성한다.
                    window[editorId] = CrossEditor;
                    // this.$log.info('＃ CrossEditor.vue => , window[editorId]);
                } else {
                    this.$log.warn('＃ CrossEditor is running => ', window[editorId].editorName);
                }
            });
        },
        OnInitCompleted(e) {
            this.$log.info('＃ CrossEditor.vue OnInitCompleted');
            var editorTarget = e.editorTarget || null;

            if (editorTarget != null) {
                editorTarget.SetValue(this.editorData);
            } else {
                this.$log.warn('＃ CrossEditor.vue editorTarget is null');
            }
        },
        getBodyValue() {
            if (CrossEditor != null) {
                return CrossEditor.GetTextValue() || 'empty';
            } else {
                return 'null';
            }
        },
    },
    created() {
        // CE 생성 전, window Object에 CE가 존재하는지 체크, 존재하지 않으면 삭제
        let cookies = document.cookie.split('; ');
        for(let cookie of cookies) {
            if(cookie.indexOf('CEnterkey_') > -1) {
                let delCookie = cookie.split('=');
                let delCookieName = delCookie[0];
                if(typeof window['ce_' + delCookieName.split('_')[3]] === 'undefined') {
                    document.cookie = delCookieName + "=; Expires=-1; max-age=-1; path=/";
                };
            }
        };
    },
    mounted() {
        this.$nextTick(() => {
            SDLUtil.importJS(`${this.$CONTEXT}/static/js/crosseditor/js/namo_scripteditor.js`)
                .then(() => {
                    this.initCrossEditor(this.getEditorId);
                })
                .catch(err => {
                    this.$log.error(err);
                });
        });
    },
    beforeDestroy() {
        // 컨포넌트 destroy 할 때 무조건 초기화 필요
        CrossEditor = null;
        window.OnInitCompleted = null;
        window[this.editorId] = null;
        this.$log.info("＃ CrossEditor.vue beforeDestroy.", CrossEditor, window.OnInitCompleted, window[this.getEditorId]);
    },
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/common/CrossEditor.vue